import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTransferConferanceIconProps extends SvgIconProps {}

/**
 * Component used to display conferance transfer icon
 * @param props - CcfTransferConferanceIcon
 * @returns
 * @example
 */
export function CcfTransferConferanceIcon(
  props: CcfTransferConferanceIconProps
) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.66675 4.66667C2.66675 4.29848 2.96522 4 3.33341 4L12.3906 4L10.862 2.4714C10.6017 2.21105 10.6017 1.78894 10.862 1.5286C11.1224 1.26825 11.5445 1.26825 11.8048 1.5286L14.4715 4.19526C14.5965 4.32029 14.6667 4.48986 14.6667 4.66667C14.6667 4.84348 14.5965 5.01305 14.4715 5.13807L11.8048 7.80474C11.5445 8.06509 11.1224 8.06509 10.862 7.80474C10.6017 7.54439 10.6017 7.12228 10.862 6.86193L12.3906 5.33333L3.33341 5.33333C2.96522 5.33333 2.66675 5.03486 2.66675 4.66667Z"
        fill="#3F5C69"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3333 11.3333C13.3333 11.7015 13.0348 12 12.6666 12L3.60939 12L5.13799 13.5286C5.39834 13.7889 5.39834 14.2111 5.13799 14.4714C4.87764 14.7318 4.45553 14.7318 4.19518 14.4714L1.52851 11.8047C1.40349 11.6797 1.33325 11.5101 1.33325 11.3333C1.33325 11.1565 1.40349 10.987 1.52851 10.8619L4.19518 8.19526C4.45553 7.93491 4.87764 7.93491 5.13799 8.19526C5.39834 8.45561 5.39834 8.87772 5.13799 9.13807L3.60939 10.6667L12.6666 10.6667C13.0348 10.6667 13.3333 10.9651 13.3333 11.3333Z"
        fill="#3F5C69"
      />
    </SvgIcon>
  );
}

export default CcfTransferConferanceIcon;
